import { AxiosProgressEvent, AxiosRequestConfig } from 'axios';

export type UploadProgress = {
  percent: number;
  loaded: number;
  total: number;
};

export type OnUploadProgressFn = (progress: UploadProgress) => void;

export type ServiceUploadingOptions = {
  onUploadProgress?: OnUploadProgressFn;
  signal?: AbortSignal;
};

export const toAxiosUploadConfig = ({
  onUploadProgress,
  signal,
}: ServiceUploadingOptions): AxiosRequestConfig => ({
  signal,
  onUploadProgress:
    onUploadProgress &&
    (({ loaded, total }: AxiosProgressEvent) => {
      if (!total) return;
      const percent = Math.round((loaded / total) * 100);
      onUploadProgress({ percent, loaded, total });
    }),
});
